var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var OAB_price_override = Drupal.settings.globals_variables.OAB_override_price_format !== 'undefined' ? Drupal.settings.globals_variables.OAB_override_price_format : 0;
  var OAB_show_decimal = Drupal.settings.globals_variables.OAB_show_decimal ? 1 : 0;
  var isDisablePrice = +$('#appointment-book-container').attr('data-disable-price');

  /* Concrete View */
  apptBook.ServicesSelectSection = function (container) {
    apptBook.ServicesSelectSection.superclass.constructor.call(this);
    this.id = 'services';
    this.container = container;
    this.apptMenu = container.find('.appt-book-page-header-menu'),
    this.servContainer = container.find('.services-container');
    this.servLessonContainer = container.find('.services-lesson');
    this.servLessonContent = this.servLessonContainer.find('.services-lesson-content');
    this.servicesLesson = this.servLessonContainer.find('.service').css('display', 'none').detach();
    this.services = this.servContainer.find('.service').css('display', 'none').detach();
    this.isLesson = 0;
    this.bookBar = this.container.find('.book-now-bar');
    this.bookBarTop = this.container.find('.book-now-bar.top');
    this.totTime = this.bookBar.find('.minutes');
    this.totPrice = this.bookBar.find('.price');
    this.bookBtn = this.bookBar.find('.button');
    this.initialised = false;
    this.minLabel = container.attr('data-minutes-label');
    this.currSymbol = container.attr('data-currency-symbol');
    this.maxSelectionsTime = parseInt(container.attr('data-max-select'));
    this.jqBod = $('body');
    this.win = $(window);
    this.boundRun = this.runBuild.bind(this);
    this.totalTime = 0;
    this.totalTimeTxt = 0;
    this.timeSlotInterval = 1;

    if (this.maxSelectionsTime === null || typeof this.maxSelectionsTime === 'undefined' || isNaN(this.maxSelectionsTime)) {
      this.maxSelectionsTime = 120;
    }
  };

  ctrlopt.extend(apptBook.ServicesSelectSection, apptBook.AbstractSection);

  apptBook.ServicesSelectSection.prototype.buildServices = function () {
    if (!this.buildParams || !this.buildParams.counterId) {
      return;
    }

    var serviceSelections, cServices,
      serviceMap = {},
      myServices = $(),
      myLessonServices = $(),
      me = this;

    me.totalTime = 0;
    me.totalTimeTxt = 0;

    // Top Book Bar Control Position
    var apptHMenu = me.jqBod.find('.appt-book-page-header-menu'),
      apptNav = apptHMenu.find('.appointment-nav'),
      bookBarTopInner = me.bookBarTop.find('.book-now-bar-inner'),
      apptNavHeight = apptNav.height(),
      apptNavPos = parseInt(apptNav.css('top'));

    is_ipad = navigator.userAgent.match(/iPad/i) != null;

    if (site.client.isMobile && !is_ipad) {
      apptHMenu.after(me.bookBarTop);
    }

    bookBarTopInner.css('top', apptNavPos + apptNavHeight + 'px');
    $(window).on('apptNavCollapse', function () {
      if (bookBarTopInner.length > 0) {
        apptNavHeight = apptNav.height();
        apptNavPos = parseInt(apptNav.css('top'));
        bookBarTopInner.css('top', apptNavPos + apptNavHeight + 'px');
      }
    });

    if (this.servLessonContainer && this.servLessonContainer[0]) {
      servLessonContainer = this.servLessonContainer.clone(),
      servLessonContent = servLessonContainer.find('.services-lesson-content');
    }

    this.counterId = this.buildParams.counterId;
    this.serviceSelIds = this.buildParams.serviceIds;
    this.maxSelectionsTime = this.buildParams.maxApptDuration >= 0 ? parseInt(this.buildParams.maxApptDuration) : this.maxSelectionsTime;
    this.slotInterval = typeof this.buildParams.timeSlotInterval !== 'undefined' ? parseInt(this.buildParams.timeSlotInterval) : this.slotInterval;
    this.maxSelectionMessage = me.jqBod.find('.appt-book-page-header .max_duration_message');
    this.unlimitedServicesMessage = me.jqBod.find('.section-sub-unlimited_services');

    if (this.maxSelectionsTime <= 0 && this.maxSelectionMessage.length > 0) {
      if (this.unlimitedServicesMessage.length > 0) {
        this.maxSelectionMessage.html(this.unlimitedServicesMessage.html());
      }
    } else {
      this.maxSelectionMessage.find('span.max_duration').html(this.maxSelectionsTime);
    }

    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      var s = this.servicesData[i];

      serviceMap[s.id] = s;
    }

    cServices = this.model.getCounterServices(this.buildParams.counterId);

    if (cServices) {
      this.services.each(function () {
        var sdata, serv,
          $this = $(this),
          onlineContentId = $this.attr('data-content-id'),
          minLabel = $this.attr('data-minutes-label'),
          currencySymbol = $this.attr('data-currency-symbol');

        if (checkService(onlineContentId)) {
          sdata = me.model.getService(onlineContentId);
          sdata.price = sdata.price || 0;
          var priceText = servicePriceOverride(sdata.price, currencySymbol);

          if (sdata) {
            serv = $this.clone();
            serv.attr('data-subsequent', sdata.subsequent);
            if (serv.find('.selection-time-date-replacement').html().length == 0) {
              serv.attr('data-duration', sdata.total_duration).find('.selection-time').text(sdata.total_duration + minLabel);
              serv.attr('data-price', sdata.price).find('.selection-price').text(priceText);
            } else {
              // Even though it's not displayed, other code still relies on these attributes being set.
              serv.attr('data-duration', sdata.total_duration);
              serv.attr('data-price', sdata.price);
              serv.find('.selection-time').hide();
              serv.find('.selection-price').hide();
              serv.find('.selection-separator').hide();
              serv.find('.selection-time-date-replacement').show();
            }
            serv.attr('data-service-id', sdata.id);
            serv.attr('data-total-duration', sdata.total_duration_with_padding);
            serv.attr('data-total-duration-with-padding', sdata.total_duration_with_padding);
            serv.find('.service_tile').click(function (e) {
              if (!$(e.target).is('.selection-selector')) {
                serv.find('.selection-selector').trigger('click');
              }
            });
            serv.find('.selection-selector').click(function (e) {
              var sText, stat,
                $this = $(this),
                icon = $this.find('.icon').remove(),
                par = $this.parents('.service'),
                dur = par.attr('data-total-duration'),
                pri = par.attr('data-price');

              if ($this.hasClass('disabled')) {
                return false;
              }
              if ($this.hasClass('selected')) {
                sText = $this.attr('data-select-text');
                stat = 'not-selected';
                $this.removeClass('selected');
                par.removeClass('selected').attr('aria-selected', 'false');
              } else {
                sText = $this.attr('data-selected-text');
                stat = 'selected';
                $this.removeClass('not-selected');
                par.removeClass('not-selected').attr('aria-selected', 'true');
              }

              $this.addClass(stat).html(sText).prepend(icon);
              par.attr('data-status', stat).addClass(stat);
              validateSelection(par);
              $('.js-appt-book-overlay').find('.js-overlay-content-container').attr('tabindex', '0').focus();
              site.restrict_navigation($('.js-appt-book-overlay').find('.js-overlay-content-container'));
            });
            // content selection on keydown
            serv.keydown(function (e) {
              if (site.getKeycode(e) === 13) {
                serv.find('.selection-selector').trigger('click');
              }
            });

            if (me.serviceSelIds) {
              if (me.serviceSelIds.indexOf(parseInt(sdata.id)) > -1) {
                serv.find('.selection-selector').trigger('click');
              }
            }

            serv.find('.service-message').click(function (e) {
              appt.showErrorDialog('redeemable');
            });
          }

          myServices = myServices.add(serv);
        }
      });

      if (this.servLessonContainer && this.servLessonContainer[0]) {
        this.servicesLesson.each(function () {
          var sdata, serv,
            $this = $(this),
            onlineContentId = $this.attr('data-content-id'),
            minLabel = $this.attr('data-minutes-label'),
            currencySymbol = $this.attr('data-currency-symbol');

          if (checkService(onlineContentId)) {
            sdata = me.model.getService(onlineContentId);
            sdata.price = sdata.price || 0;
            me.isLesson = 1;
            var priceText = servicePriceOverride(sdata.price, currencySymbol);

            if (sdata) {
              serv = $this.clone();
              if (serv.find('.selection-time-date-replacement').html().length == 0) {
                serv.attr('data-total-duration', sdata.total_duration_with_padding).find('.selection-time').text(sdata.total_duration + minLabel);
                serv.attr('data-price', sdata.price).find('.selection-price').text(priceText);
              } else {
                serv.find('.selection-time').hide();
                serv.find('.selection-price').hide();
                serv.find('.selection-separator').hide();
                serv.find('.selection-time-date-replacement').show();
              }
              serv.attr('data-service-id', sdata.id);
              serv.find('.service_tile').click(function (e) {
                if (!$(e.target).is('.selection-selector')) {
                  serv.find('.selection-selector').trigger('click');
                }
              });
              serv.find('.selection-selector').click(function (e) {
                var sText, stat,
                  $this = $(this),
                  icon = $this.find('.icon').remove(),
                  par = $this.parents('.service'),
                  dur = par.attr('data-total-duration'),
                  pri = par.attr('data-price');

                if ($this.hasClass('selected')) {
                  sText = $this.attr('data-select-text');
                  stat = 'not-selected';
                  $this.removeClass('selected');
                  par.removeClass('selected');
                } else {
                  sText = $this.attr('data-selected-text');
                  stat = 'selected';
                  $this.removeClass('not-selected');
                  par.removeClass('not-selected');
                }

                $this.addClass(stat).html(sText).prepend(icon);
                par.attr('data-status', stat).addClass(stat);
                validateSelection(par);
              });

              if (me.serviceSelIds) {
                if (me.serviceSelIds.indexOf(parseInt(sdata.id)) > -1) {
                  serv.find('.selection-selector').trigger('click');
                }
              }

              serv.find('.service-message').click(function (e) {
                appt.showErrorDialog('redeemable');
              });
            }

            myLessonServices = myLessonServices.add(serv);
          }
        });
      }

      // me.services.detach();
      me.servLessonContainer.detach();
      var collapsable = this.servContainer.data('collapsable');
      var sectionDisplay = this.servContainer.data('section-display');
      var sectionsDefaultOpen = this.servContainer.data('sections-defaultopen') || '';

      sectionsDefaultOpen = sectionsDefaultOpen.toLowerCase().split(',');
      $.each(sectionsDefaultOpen, function (index, value) {
        sectionsDefaultOpen[index] = value.trim();
      });
      function getServiceType(thisService) {
        return $(thisService).find('.service-type').html().trim().toLowerCase().replace(/\s/g, '_');
      }

      var servicesHash = {};

      for (i = 0; i < myServices.length; ++i) {
        var thisService = myServices[i];
        var serviceType = getServiceType(thisService);

        servicesHash[serviceType] = 1;
      }

      if (collapsable && Object.keys(servicesHash).length > 1) {
        // Create container to hold collapsable sections
        var collapsable_section = document.createElement('div');
        // Create the collapsable sections and their base elements, in the order defined by section-display
        // String parsing is a little complex here because the service descriptions can contain commas, so we can't just split on commas...
        var sections = [];
        var serviceDescriptions = new Object();
        var strArray = sectionDisplay.split('');
        var curServiceName = '';
        var curServiceDesc = '';

        while (strArray.length != 0) {
          var thisChar = strArray.splice(0, 1);

          if (thisChar != ',' && thisChar != '(' && thisChar != ')') {
            curServiceName += thisChar;
          }
          if (thisChar == ',') {
            sections.push(curServiceName.trim().toLowerCase());
            serviceDescriptions[curServiceName.trim().toLowerCase()] = '';
            curServiceName = '';
          }
          if (thisChar == '(') {
            endDesc = 0;
            while (endDesc == 0) {
              var thisCharD = strArray.splice(0, 1);

              if (thisCharD != ')') {
                curServiceDesc += thisCharD;
              } else {
                endDesc = 1;
                serviceDescriptions[curServiceName.trim().toLowerCase()] = curServiceDesc;
                sections.push(curServiceName.trim().toLowerCase());
                curServiceName = '';
                curServiceDesc = '';
                strArray.splice(0, 1); // Remove comma after the )
              }
            }
          }
        }
        if (curServiceName.length > 0) {
          sections.push(curServiceName.trim().toLowerCase());
          serviceDescriptions[curServiceName.trim().toLowerCase()] = '';
        }

        for (i = 0; i < sections.length; ++i) {
          var section = sections[i];
          var sectionDescription = serviceDescriptions[section];
          var sectionClass = section.replace(/\s/g, '_');
          var sectionElement = document.createElement('div');

          $(sectionElement).addClass('lesson-section-' + sectionClass).addClass('lesson-section-block');
          var sectionHeader = document.createElement('h2');

          $(sectionHeader).addClass('lesson-section-header js-lesson-section-header');
          $(sectionHeader).attr({
            'tabindex': '0',
            'aria-expanded': 'false',
            'role': 'button'
          });
          var sectionContent = document.createElement('div');

          $(sectionContent).addClass('section-content');
          var sectionHeaderMarker = '&ndash;';

          if ($.inArray(section, sectionsDefaultOpen) <= -1) {
            sectionHeaderMarker = '+';
            $(sectionContent).addClass('closed');
          }
          var sectionSubheader = "<div class='section-subheader'>" + sectionDescription + '</div>';

          $(sectionHeader).html("<div class='section-header js-section-header' data-section='" + section + "'><span>" + sectionHeaderMarker + '</span>' + section + 'S</div>' + sectionSubheader);

          sectionElement.appendChild(sectionHeader);
          sectionElement.appendChild(sectionContent);
          this.servContainer.append(sectionElement);
        }

        // Hook up events to expand/contract the sections when their headers are clicked
        this.servContainer.find('.section-header').click(function () {
          var sectionContent = $(this).parent().parent().find('.section-content');
          var $sectionHeader = $(this).parent();

          if (sectionContent.hasClass('closed')) {
            sectionContent.removeClass('closed');
            $(this).html('<span>&ndash;</span>' + $(this).data('section') + 'S');
            sectionContent.css({ 'max-height': sectionContent.get(0).scrollHeight });
            // adding tabindex for selecting service contents
            sectionContent.find('.js-service').attr({
              'tabindex': '0',
              'role': 'gridcell',
              'aria-selected': 'false'
            });
            sectionContent.find('.js-selection_selector').attr('tabindex', '0');
            $sectionHeader.attr('aria-expanded', 'true');
          } else {
            sectionContent.addClass('closed');
            $(this).html('<span>+</span>' + $(this).data('section') + 'S');
            sectionContent.css({ 'max-height': '0px' });
            // removing tabindex for selecting contents when accordian is collapsed
            sectionContent.find('.js-service').attr('tabindex', '-1');
            sectionContent.find('.js-selection_selector').removeAttr('tabindex');
            $sectionHeader.attr('aria-expanded', 'false');
          }
        });
        this.servContainer.find('.js-lesson-section-header').focus(function () {
          $(this).parent().find('.js-service').attr('tabindex', '-1');
        });
        // book appointment page accordion keydown event triggering
        this.servContainer.find('.js-lesson-section-header').keydown(function (e) {
          if (site.getKeycode(e) === 13) {
            $(this).find('.js-section-header').trigger('click');
          }
        });
        // Now loop over the actual services and add them to the relevant container
        for (i = 0; i < myServices.length; ++i) {
          var thisService = myServices[i];
          var serviceType = getServiceType(thisService);
          var parentSection = $('.lesson-section-' + serviceType + ' .section-content');

          if (parentSection) {
            parentSection.append(thisService);
          }
        }

        // Finally unhide the sections that have any services, remove any that do not
        var mySections = $('.lesson-section-block');

        for (i = 0; i < mySections.length; ++i) {
          var thisSection = mySections[i];

          if ($(thisSection).find('.section-content').children().length > 0) {
            $(thisSection).show();
          } else {
            $(thisSection).remove();
          }
        }
      } else {
        // If the collapsable class is not present on the servContainer then just use the old/default behavior
        this.servContainer.append(myServices);
      }
      if (this.servLessonContainer && this.servLessonContainer[0] && this.isLesson) {
        servLessonContent.append(myLessonServices);
        this.servContainer.after(servLessonContainer);
        this.servLessonContainer = this.container.find('.services-lesson');
        this.servLessonContent = this.servLessonContainer.find('.services-lesson-content');
        myLessonServices.css('display', 'block');
        // Resetting the isLesson variable
        this.isLesson = 0;
      }
      myServices.css('display', 'block');
      if (myServices.length > 1) {
        apptBook.equalHeights(myServices);
      }
      if (myLessonServices.length > 1) {
        apptBook.equalHeights(myLessonServices);
      }

      updateBar();
      this.bookBtn.off('click');
      this.bookBtn.click(function (e) {
        var updateData,
          anStr = serviceSelections.length + 'Apt',
          $this = $(this);

        if ($this.hasClass('disabled')) {
          return;
        }
        var serviceNames = serviceSelections.map(function (element) {
          return element.serviceName.trim();
        }).join('|');

        site.track.evtLink({
          event_name: 'appointmentBooking_Service',
          event_category: 'appointment booking',
          event_action: 'services selected',
          event_label: serviceNames
        });

        updateData = {
          sectionId: 'next',
          params: {
            counterId: me.counterId,
            services: serviceSelections,
            slotInterval: me.slotInterval,
            appointmentDuration: me.totalTime,
            updateMode: me.updateMode
          }
        };
        if (site.client.isMobile) {
          me.bookBarTop.remove();
        }
        me.model.update(updateData);
      });
      this.bookBtn.keydown(function (e) {
        if (site.getKeycode(e) === 13) {
          $(this).trigger('click');
        }
      });
      this.win.on('resize', this.boundResize);
    }

    function checkService(id) {
      if (cServices) {
        for (var i = 0, len = cServices.length; i < len; i += 1) {
          var sId = cServices[i];

          if (id === serviceMap[sId].online_content_id) {
            return true;
          }
        }
      }

      return false;
    }

    function validateSelection(lastSelection) {
      var selected = me.servContainer.find('.service.selected'), serviceSelectionIds = [];

      if (!lastSelection.hasClass('selected')) {
        updateBar(lastSelection);

        return;
      }
      var selectedCounterData = _.find(me.model.countersData, { 'id': me.counterId }) || me.model.countersData[0];
      var maxSvcs = selectedCounterData['max_appointment_services'];

      if ((maxSvcs > 0) && (selected.length > maxSvcs)) {
        deselectService(lastSelection);
        launchMaxSvcOverlay();

        return null;
      }

      // Break down services into different categories
      var nonSubsequentSelfServices = [], subsequentSelfServices = [];
      var totalDuration = 0;

      selected.each(function (i) {
        var $this = $(this);
        var serviceId = parseInt($this.attr('data-service-id'));
        var isSubsequent = $(this).attr('data-subsequent') == '1';

        if (isSubsequent) {
          subsequentSelfServices.push(serviceId);
        } else {
          nonSubsequentSelfServices.push(serviceId);
        }
        serviceSelectionIds.push(serviceId);
        var duration = parseInt($this.data('total-duration'));

        if (!isNaN(duration)) {
          totalDuration += duration;
        }
      });

      if (totalDuration > selectedCounterData['max_appointment_duration']) {
        deselectService(lastSelection);
        launchMsOverlay();

        return null;
      }

      function validateCounterHasCalendarWithTimeslotsThatSupportServices(servicesToValidate) {
        if (servicesToValidate.length == 0) {
          return;
        }
        me.model.getCounter(me.counterId, { service_id: servicesToValidate }, function (data) {
          var counterData = data, hasTimeSlots = 0,
            calData = counterData.calendars;

          if (!calData || !calData.length) {
            lastSelection.removeClass('selected');
            lastSelection.find('select').val('0');
            lastSelection.data('status', 'not-selected');
            lastSelection.find('.service-select').removeClass('selected');
            $(document).trigger('selectBox.refresh');
            launchMsOverlay();
            this.updateBar(lastSelection);
          } else {
            for (var i = 0, len = calData.length; i < len; i += 1) {
              hasTimeSlots += calData[i].timeslots.length;
            }
            if (!hasTimeSlots) {
              launchSelErrOverlay(lastSelection);
            } else {
              numValidated += 1;
              if (numValidated == numToValidate) {
                updateBar(lastSelection); // If we validated all service sets, we can finally call updateBar()
              }
            }
          }
        });
      }

      numValidated = 0;
      // We are doing to call validateCounterHasCalendarWithTimeslotsThatSupportServices() once for each set of services
      // that will eventually map to it's own appointment.
      numToValidate = (nonSubsequentSelfServices.length ? 1 : 0) +
                      (subsequentSelfServices.length ? 1 : 0);
      this.updateBar = updateBar;
      validateCounterHasCalendarWithTimeslotsThatSupportServices(nonSubsequentSelfServices);
      validateCounterHasCalendarWithTimeslotsThatSupportServices(subsequentSelfServices);
    }

    // appt-book-services-unavailabe-overlay
    // overlay_unavailable_service_content
    function launchSelErrOverlay(lastSelection) {
      var errKey = 'unavail_svc';

      apptBook.showErrorDialog(errKey);
    }

    function launchMsOverlay() {
      var errKey = 'max_limit';

      apptBook.showErrorDialog(errKey);
      $('.max_duration').html(me.maxSelectionsTime);
    }

    function launchMaxSvcOverlay() {
      var errKey = 'max_services';

      apptBook.showErrorDialog(errKey);
      var counter = _.find(me.model.countersData, { id: me.counterId });
      var $svcMax = $('.max_services');

      if (counter && $svcMax.length > 0) {
        $svcMax.text(counter['max_appointment_services']);
      }
    }

    function deselectService($svcNode) {
      selBtn = $svcNode.find('.selection-selector').removeClass('selected').addClass('not-selected');
      $svcNode.removeClass('selected').attr('data-status', 'not-selected');
      sText = selBtn.attr('data-select-text');
      selBtn.text(sText);
    }

    function updateBar(lastSelection) {
      var totalPrice = OAB_show_decimal ? 0.00 : 0;
      var sel, selBtn, sText, sTime, icon,
        noselected = me.servContainer.find('.service').not('.selected'),
        selected = me.servContainer.find('.service.selected'),
        curTime = lastSelection ?
          lastSelection.hasClass('selected') ?
            parseInt(lastSelection.attr('data-total-duration'))
            : -parseInt(lastSelection.attr('data-total-duration'))
          : 0,
        curTimeTxt = lastSelection ?
          lastSelection.hasClass('selected') ?
            parseInt(lastSelection.attr('data-duration'))
            : -parseInt(lastSelection.attr('data-duration'))
          : 0;
      var lastTotalTime = me.totalTime;

      me.totalTime += curTime;
      me.totalTimeTxt += curTimeTxt;

      // merge selected normal services with special services
      if (me.servLessonContainer && me.servLessonContainer[0]) {
        var selectedLesson = me.servLessonContent.children('.selected');
        var noselectedLesson = me.servLessonContent.children().not('.selected');

        $.merge(selected, selectedLesson);
        $.merge(noselected, noselectedLesson);
      }

      serviceSelections = [];
      if (me.maxSelectionsTime > 0) {
        if (me.totalTime > me.maxSelectionsTime) {
          // alert("Whoops, selected too many. Sorry, can't do that.");

          launchMsOverlay();

          var $sel;

          if (lastSelection && (lastTotalTime <= me.maxSelectionsTime)) {
            $sel = lastSelection;
            me.totalTime -= curTime;
            me.totalTimeTxt -= curTimeTxt;
          } else {
            var lastIndex = selected.length - 1;

            $sel = selected.eq(lastIndex);
            sTime = parseInt($sel.attr('data-total-duration'));
            sTimeTxt = parseInt($sel.attr('data-duration'));
            me.totalTime -= sTime;
            me.totalTimeTxt -= sTimeTxt;
          }

          deselectService($sel);
          updateBar();

          return;
        }
      }

      me.totalTime = 0;
      me.totalTimeTxt = 0;

      selected.each(function (i) {
        var $this = $(this),
          time = parseInt($this.attr('data-total-duration')),
          timeWithPadding = parseInt($this.attr('data-total-duration-with-padding')),
          timeTxt = parseInt($this.attr('data-duration')),
          price = OAB_show_decimal ? parseFloat($this.attr('data-price')) : parseInt($this.attr('data-price')),
          serviceId = parseInt($this.attr('data-service-id')),
          serviceName = $this.find('.service-title').text(),
          serviceType = $this.find('.service-type').text(),
          subsequent = parseInt($this.attr('data-subsequent'));

        me.totalTime += time;
        me.totalTimeTxt += timeTxt;
        totalPrice += price;

        $this.removeClass('time-out-range');

        serviceSelections.push({
          serviceId: serviceId,
          serviceDuration: timeTxt,
          serviceDurationWithPadding: timeWithPadding,
          servicePrice: price,
          serviceName: serviceName,
          serviceType: serviceType,
          subsequent: subsequent
        });
      });

      noselected.each(function (i) {
        var $this = $(this),
          time = parseInt($this.attr('data-total-duration'));

        $this.removeClass('time-out-range');

        if (me.maxSelectionsTime > 0 && me.totalTime > 0 && me.totalTime <= me.maxSelectionsTime) {
          if (time > (me.maxSelectionsTime - me.totalTime)) {
            $this.addClass('time-out-range');
          }
        }
      });
      if (me.totalTime > 0) {
        me.bookBtn.removeClass('disabled');
        // When book now button enabled we make the button tabbable
        me.bookBtn.attr({
          'tabindex': '0',
          'role': 'button'
        });
      } else {
        me.bookBtn.addClass('disabled');
        // when book now button disabled, remove tabindex
        me.bookBtn.removeAttr('tabindex role');
      }
      totalPrice = totalPrice || 0;
      var totalPriceText = servicePriceOverride(totalPrice, me.currSymbol);

      me.totTime.text(me.totalTimeTxt + me.minLabel);
      me.totPrice.text(totalPriceText);
    }

    function onResize() {
      myServices.css('height', 'auto');
      if (myServices.length > 1) {
        apptBook.equalHeights(myServices);
      }
      myLessonServices.css('height', 'auto');
      if (myLessonServices.length > 1) {
        apptBook.equalHeights(myLessonServices);
      }
    }

    function servicePriceOverride(price, currencySymbol) {
      var priceText, priceValue;

      if (isDisablePrice && !+price) {
        me.container.find('.selection-separator').hide();
        me.container.find('.separator').hide();
        me.bookBar.find('.separator').hide();
        priceText = '';
      } else {
        priceValue = OAB_show_decimal ? parseFloat(price).toFixed(2) : parseInt(price);
        priceText = OAB_price_override ? priceValue + currencySymbol : currencySymbol + priceValue;
      }

      return priceText;
    }

    this.boundResize = onResize.bind(this);

    this.win.on('resize', this.boundResize);
  };

  apptBook.ServicesSelectSection.prototype.runBuild = function () {
    var hasVirtual = localStorage.getItem('virtual_oab') || 0;

    if (hasVirtual) {
      $('.appt-book-link', this.container).addClass('hidden');
    }
    this.buildServices();
  };

  apptBook.ServicesSelectSection.prototype.onUpdate = function (data) {
    var aPgName = document.title + ' - Services Select';

    if (this.boundResize) {
      this.win.off('resize', this.boundResize);
    }
    if (data.sectionId === this.id) {
      this.buildParams = data.params;
      if (data.params.updateMode) {
        this.updateMode = true;
      } else {
        this.updateMode = false;
      }
      /* this.countersData = this.model.getCounters();*/
      this.servicesData = this.model.getServices();
      this.servContainer.empty();
      if (this.servLessonContainer && this.servLessonContainer[0]) {
        this.servLessonContent.empty();
      }

      apptBook.sectionManager.on('transition_in_start', this.boundRun);
    } else {
      apptBook.sectionManager.off('transition_in_start', this.boundRun);
    }
  };

  Drupal.behaviors.apptBookServices = {
    attach: function (context) {
      var view = new apptBook.ServicesSelectSection($('#services'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
